import { Box, Stepper, Step, StepLabel, StepConnector } from "@mui/material";
import { styled } from "@mui/material/styles";
import { steps } from "../../utils/CommonUtils/constants";
import "./AssessmentStepper.css";

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  "&.MuiStepConnector-alternativeLabel": {
    left: "calc(-50% + 12px)",
    right: "calc(50% + 12px)",
  },
  "& .MuiStepConnector-line": {
    borderTopStyle: "dotted",
    borderTopWidth: 2.5,
    borderColor: "6E6E6E !important",
  },
  "&.Mui-completed .MuiStepConnector-line": {
    borderColor: "#A2C357 !important",
  },
  "&.Mui-active .MuiStepConnector-line": {
    borderColor: "#A2C357 !important",
  },
}));

function AssessmentStepper({ currentStep, t }) {
  const activeStep = currentStep - 1;

  return (
    <Box className="assessment-loading-stepper">
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        connector={<CustomConnector />}
      >
        {steps(t).map((label, index) => (
          <Step
            key={label}
            sx={{
              "& .MuiStepLabel-root .Mui-completed": {
                color: "#A2C357",
              },
              "& .MuiStepIcon-completed": {
                color: "#A2C357",
              },
              "& .MuiStepLabel-root .Mui-active": {
                color: "#A2C357",
              },
            }}
          >
            <StepLabel>
              <span
                className={`step-label ${index === activeStep ? "active-step" : ""}`}
              >
                {label}
              </span>
            </StepLabel>
            {index === 1 && (
              <CustomConnector
                sx={{
                  "& .MuiStepConnector-line": {
                    borderTopStyle: "solid",
                    borderTopWidth: 2.5,
                  },
                }}
              />
            )}
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}

export default AssessmentStepper;
